import React from "react";
import { CDN_URL } from "../../utils/constants";
import { useDispatch } from "react-redux";
import { addItem } from "../../store/cartSlice";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ResMenuItems = ({ itemdata = [] }) => {
  const dispatch = useDispatch();

  const handleClick = (item) => {
    dispatch(addItem(item));
    toast.success("Item added successfully!", {
      position: "top-center",
      autoClose: 700,
    });
  };

  return (
    <div className="flex flex-col gap-2 xs:gap-3 max-w-[95%] xs:max-w-[85%] sm:max-w-[75%] md:max-w-6/12 mx-auto">
      <ToastContainer /> {/* Ensure ToastContainer is rendered */}
      {itemdata.map((item, index) => {
        const name = item?.card?.info?.name || "Unnamed Item";
        const description = item?.card?.info?.description || "No description available.";
        const price = (item?.card?.info?.price || item?.card?.info?.defaultPrice || 0) / 100;
        const imageId = item?.card?.info?.imageId || "";

        return (
          <div
            key={index}
            className="flex justify-between items-center p-2 xs:p-3 sm:p-5 border border-gray-200 rounded-lg bg-white shadow-md hover:shadow-lg transition duration-300"
          >
            {/* Item Info */}
            <div className="flex-1 min-w-0 pr-2 xs:pr-4">
              <h4 className="font-bold text-sm xs:text-base sm:text-lg truncate text-gray-800">
                {name}
              </h4>
              <p className="text-gray-600 text-xs xs:text-sm sm:text-base line-clamp-2 mt-1">
                {description}
              </p>
              <p className="text-green-600 font-semibold text-xs xs:text-sm sm:text-base mt-2">
                ₹{price}
              </p>
            </div>

            {/* Item Image with Add Button */}
            <div className="relative w-[50px] h-[50px] xs:w-[80px] xs:h-[80px] sm:w-[100px] sm:h-[100px] flex-shrink-0">
              {imageId ? (
                <img
                  src={`${CDN_URL}${imageId}`}
                  alt={name}
                  className="w-full h-full object-cover rounded"
                />
              ) : (
                <div className="w-full h-full bg-gray-200 rounded flex items-center justify-center text-gray-500 text-xs">
                  No Image
                </div>
              )}
              <button
                className="absolute bottom-0 xs:bottom-2 left-1/2 transform -translate-x-1/2 px-2 xs:px-3 py-1 xs:py-2 text-xs xs:text-sm sm:text-base bg-blue-500 text-white font-semibold rounded shadow hover:bg-blue-600 transition duration-300"
                onClick={() => handleClick(item)}
                aria-label={`Add ${name} to cart`}
              >
                Add
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ResMenuItems;
